/* eslint-disable react/no-array-index-key */
import { Fragment } from 'react';

const loadingAmount = 3;
const LoadingInstructions = () => (
  <div className="animate-pulse flex space-x-4">
    <div className="grid grid-cols-4 gap-4 w-full">
      {[...Array(loadingAmount)].map((_, index) => (
        <Fragment key={index}>
          <div className="h-4 bg-slate-300 rounded col-span-2" />
          <div className="h-4 bg-slate-300 rounded col-span-2" />
        </Fragment>
      ))}
    </div>
  </div>
);

export default LoadingInstructions;
